/** Merges conditional class lists and resolves Tailwind conflicts (shadcn/ui convention, TZ 8.13). */
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function classNames(...classInputs: ClassValue[]): string {
  return twMerge(clsx(classInputs));
}
